// export {default} from './ClientProfile.connect';
import {SCREEN_NAMES} from '/enum/tealium.enum';
import {withScreenPersistence} from '/util/async-storage';

import ClientProfileConnected from './ClientProfile.connect';

export default withScreenPersistence(
  ClientProfileConnected,
  SCREEN_NAMES.clientProfile,
);
